import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/contexts/AuthContext';
import { NavigationProvider } from '@/contexts/NavigationContext';
import { SectionProvider } from '@/contexts/SectionContext';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { AuthContainer } from '@/components/auth/AuthContainer';
import { AppContentWrapper } from '@/components/AppContentWrapper';
import { Toaster } from '@/components/ui/toaster';

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (renamed from cacheTime in v5)
      retry: 3,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <NavigationProvider>
          <SectionProvider>
            <div className="min-h-screen bg-background text-romanian">
              <ProtectedRoute fallback={<AuthContainer />}>
                <AppContentWrapper />
              </ProtectedRoute>
              <Toaster />
            </div>
          </SectionProvider>
        </NavigationProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;